import React from 'react';
import Marquee from 'react-fast-marquee';

const BRANDS = ['3M 1080', 'AVERY DENNISON', 'ORAFOL 970RA', 'AURA PPF', 'HEXIS SKINTAC', 'MACTAC', 'ARLON', 'APA'];

export default function BrandMarquee() {
  return (
    <section className="relative py-8 border-y mi-line bg-[#0A0A0A]">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {BRANDS.concat(BRANDS).map((b, i) => (
          <span key={`${b}-${i}`} className="mi-marquee-item">{b}</span>
        ))}
      </Marquee>
    </section>
  );
}
